export default "__VITE_ASSET__BKGS38Gj__"